// extracted by mini-css-extract-plugin
export default {"tabs":"d7-z","tablist":"e7-z","tablistItem":"f7-z"};